import React from 'react';
import { Select as BaseSelect, SelectProps } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './style.css';

const Select = ({ disabled, options, ...props }: SelectProps) => {
  return (
    <BaseSelect
      {...props}
      className={`w-full ${disabled ? 'select-disabled' : 'select-enabled'}`}
      bordered={false}
      suffixIcon={<DownOutlined className={`${!disabled && 'text-white'}`} />}
      disabled={disabled}
    >
      {options?.map((option) => (
        <BaseSelect.Option key={`${option.value}`} value={option.value}>
          {option.label}
        </BaseSelect.Option>
      ))}
    </BaseSelect>
  );
};

export default Select;
